import { postAuthenticated } from './http';

export const submitSupportRequest = (payload) =>
  postAuthenticated('/api/support', payload);
